export default __webpack_public_path__ + "static/media/Finger-Rings.f4f4411c.jpg";